import actions from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-complaints/actions';

export default () => ({
    state: {},
    actions: {
        ...actions,
    },
});